import { lazy, useEffect, useState, type ComponentType, type FC } from 'react';

import { VIEW_RESOLVER } from '@/data/constants';
import { IPageLayout } from './page-layout.interface';

const PageLayout: FC<IPageLayout> = ({ typeId }) => {
  const { API_VERSION_V2: apiVersion, MAIN_CONTENT_COLLECTION, PAGE_LAYOUT_SINGLE_COLUMN } = VIEW_RESOLVER;
  const [ViewResolverSection, setViewResolverSection] = useState<ComponentType<any> | null>(null);
  const [ListingPageComponent, setListingPageComponent] = useState<ComponentType<any> | null>(null);
  const isClpPage = typeId === PAGE_LAYOUT_SINGLE_COLUMN;

  useEffect(() => {
    if (typeof window !== 'undefined') {
      // @ts-ignore
      setViewResolverSection(lazy(() => import('ldpViewResolverSdm/Section')));
      // @ts-ignore
      setListingPageComponent(lazy(() => import('ldpViewResolverSdm/ListingPageComponent')));
    }
  }, []);

  return (
    <>
      {isClpPage && ViewResolverSection ? (
        <ViewResolverSection apiVersion={apiVersion} layoutSection={MAIN_CONTENT_COLLECTION} />
      ) : (
        ListingPageComponent && <ListingPageComponent />
      )}
    </>
  );
};

export default PageLayout;
